import React from "react";

import { useSelector } from "react-redux";

import { Column, Row } from "components/Layout";
import { Paper } from "components/Paper";

import AgGridContainer from "components/AgGrid/AgGridContainer";

import { AgGridTables } from "constants/aggrid";
import { ModalTypes } from "constants/navigation";

import { openModalLink } from "lib/navigation";

import { selectSaleStatusesAggridData } from "selectors/aggrid/saleStatuses";
import { useCanAddSaleStatusPermission } from "hooks";
import { SaleStatusColumnDef } from "constants/columnDefinitions/saleStatuses";

export const columnDefs = Object.values(SaleStatusColumnDef);

export const SaleStatusTable = () => {
  const rowData = useSelector(selectSaleStatusesAggridData);

  const hasCanAddSaleStatusPermission = useCanAddSaleStatusPermission();

  const openCreateSaleStatus = () => openModalLink(ModalTypes.SaleStatus);

  const additionalActions = [
    {
      title: "Create Sale Status",
      dataTour: "createSaleStatus",
      onClick: openCreateSaleStatus,
      isDisabled: !hasCanAddSaleStatusPermission,
    },
  ];

  return (
    <AgGridContainer
      rowData={rowData}
      columnDefs={columnDefs}
      additionalActions={additionalActions}
      tableName={AgGridTables.SALE_STATUSES}
    />
  );
};

export const SaleStatuses = () => (
  <Row flexGrow full>
    <Column margin={2} gridGap={2} full>
      <Paper square>
        <SaleStatusTable />
      </Paper>
    </Column>
  </Row>
);
